app.service('MOP', function (log, orderConfig, console, message, modal, localStorage, sessionStorage, loading, broker, cookie, mopPaymentDataManager) {

	var config;
	var loadingTimeout, initializingTimeout, initializedTimeout;

	broker.on('PAGE_CONFIG_INIT', function () {
		config = orderConfig.getData();
		if (config.pageType == 'order-payment-module' || config.pageType == 'account-payment-module' || config.pageType == 'gift-card-order-payment-module') {
			fastInit();
		}
	});

	function addLogForATR(event) {
		var data = JSON.parse(localStorage.getItem('komunikacja_MOP-SI') || '[]');
		data.push(event);
		localStorage.setItem('komunikacja_MOP-SI', JSON.stringify(data));
	}

	function event(f04) {
		addLogForATR(f04);
		log.event({ id: 'komunikacja_MOP-SI', f04: f04, f03: config.orderNumber });
		UA.interaction('komunikacja_MOP-SI', f04, config.orderNumber);
	}

	function init() { }
	let isOneInit = false;
	function fastInit() {

		loadingTimeout = setTimeout(function () {
			cancelPayment('PAYMENT_ORDER_LOADING_TIMEOUT');
		}, config.webComponentLoadingTimeout);
		initializingTimeout = setTimeout(function () {
			cancelPayment('PAYMENT_ORDER_INITIALIZING_TIMEOUT');
		}, config.webComponentInitializingTimeout);
		initializedTimeout = setTimeout(function () {
			cancelPayment('PAYMENT_ORDER_INITIALIZED_TIMEOUT');
		}, config.webComponentInitializedTimeout);


		if (!isOneInit) {
			isOneInit = true;
			window.broker.on('PAYMENT_ORDER_REJECTED', function () {
				console.log('SI: przechwycenie informacji że MOP się nie uruchomił, ma problem, oddaje SI przekierowanie użytkownika dalej po błędzie');
				mopPaymentDataManager.save(mopPaymentDataManager.buildError(config));
				cancelPayment('PAYMENT_ORDER_REJECTED');
			});

			window.broker.on('PAYMENT_ORDER_PREVIEW_ORDER', function () {
				event('PAYMENT_ORDER_PREVIEW_ORDER');
				console.log('SI: przejście na finalizację aby tylko zobaczyć podgląd');
				goToNextPage();
			});

			window.broker.on('PAYMENT_ORDER_SUCCESS', function (e, paymentData) {
				event('PAYMENT_ORDER_SUCCESS');
				success(paymentData);
			});

			window.broker.on('PAYMENT_ORDER_ERROR', function () {
				event('PAYMENT_ORDER_ERROR');
				console.log('SI: przejście na finalizację z porażką');
				mopPaymentDataManager.save(mopPaymentDataManager.buildError(config));
				goToNextPage();
			});

			window.broker.on('PAYMENT_ORDER_USER_ACTION', function () {
				event('PAYMENT_ORDER_USER_ACTION');
			});

			window.broker.on('PAYMENT_ORDER_TIMEOUT_USER_ACCEPTED', function () {
				event('PAYMENT_ORDER_TIMEOUT_USER_ACCEPTED');
				goToNextPage('/customer-current-orders.bhtml');
			});

			window.broker.on('PAYMENT_ORDER_USER_ACCOUNT', function () {
				event('PAYMENT_ORDER_USER_ACCOUNT');
				goToNextPage('/customer-current-orders.bhtml');
			});

			window.broker.on('PAYMENT_ORDER_MODULE_LOADING', function () {
				event('PAYMENT_ORDER_MODULE_LOADING');
				clearTimeout(loadingTimeout);
			});

			window.broker.on('PAYMENT_ORDER_MODULE_INITIALIZING', function () {
				event('PAYMENT_ORDER_MODULE_INITIALIZING');
				clearInterval(initializingTimeout);
			});

			window.broker.on('PAYMENT_ORDER_MODULE_INITIALIZED', function () {
				event('PAYMENT_ORDER_MODULE_INITIALIZED');
				$('#order-payment-module, #account-payment-module').addClass('mop-initialized');
				clearInterval(initializedTimeout);
			});
		}
	}

	function goToNextPage(href) {
		if (!href) {
			if (config.pageType == 'account-payment-module') {
				/**
				 * PAYMENT - opłacenie składki w KME
				 * ACTIVATION - aktywacja ochrony sprzętu w KME
				 * CHANGE_TOKEN - zmiana metody płatności w KME
				 * INSTALMENT - upselling
				 */
				if (config.processType === 'PAYMENT' || config.processType === 'ACTIVATION' || config.processType === 'CHANGE_TOKEN') {
					href = `/customer-subscription-payments.bhtml`;
				} else if (config.processType === 'INSTALMENT') {
					href = `/customer-order-preview.bhtml?orderNumber=${encodeURIComponent(config.orderNumber)}`;
				} else {
					href = '/konto-platosc-powrot.bhtml?paymentId=' + config.paymentModuleDataId;
				}
			} else if (config.pageType == 'gift-card-order-payment-module') {
				href = '/karta-podarunkowa-potwierdzenie.bhtml';
			} else {
				href = '/order-finalize.bhtml';
			}
		}
		event('PAYMENT_ORDER_REDIRECT');
		if (cookie.get('atrUser')) {					// na potrzeby testów chwilę przetrzymuję przekierowanie aby można było sprawdzić czy wrócił na mop
			console.log('Specjalnie dla testów ATR przetrzymujemy przekierowanie o 2 sekundy, aby można było sprawdzić czy wrócił na MOP');
			setTimeout(function () {
				redirect(href);
			}, 2000);
		} else {
			redirect(href);
		}
	}

	function redirect(href) {
		loading.redirect({
			href: href,
			soft: false		// docelowo mop będzie bez skryptów stron 3 wię będzie i tak wymagał przekierowania
		});
	}
	var cancelProccesing = false;
	function cancelPayment(cancelType) {
		addLogForATR(cancelType);
		window.broker.trigger('CANCEL_ORDER_PAYMENT_PROCESSING');
		$('payment-module').remove();
		if (cancelProccesing) {
			return;
		}
		cancelProccesing = true;
		function errorMessage() {
			message.get('payment-module-webcomponent-error').then(function (result) {
				loading.stop();
				modal.generate({
					id: 'payment-module-webcomponent-error',
					content: result,
					close: false,
					buttons: [
						{
							text: 'Spróbuj ponownie',
							cssClass: 'btn-second',
							click: function () {
								modal.close();
							}
						}
					],
					callbackClose: function () {
						goToNextPage();
					}
				});
			});
		}
		clearTimeout(loadingTimeout);
		clearInterval(initializingTimeout);
		clearInterval(initializedTimeout);
		event(cancelType);
		if (config.isPaymentCancellable) {
			event('PAYMENT_ORDER_SEND_CANCEL');
			loading.start();
			$.ajax({
				url: '/orderpayment/paymentmodule/transactions/delete.ltr',
				method: 'POST',
				dataType: "json",
				data: {
					paymentId: config.paymentModuleDataId
				},
				success: function (json) {
					if (cancelType === 'PAYMENT_ORDER_REJECTED') {
						console.log('błąd: PAYMENT_ORDER_REJECTED');
						event('PAYMENT_ORDER_SEND_CANCEL_ERROR');
						errorMessage();
					} else if (json.error) {
						console.log('błąd: JSON.ERROR:' + json.error);
						event('PAYMENT_ORDER_SEND_CANCEL_ERROR');
						errorMessage();
					} else {
						console.log('udane przełączenie płatności');
						goToNextPage();
					}
				},
				error: function () {
					console.log('błąd komunikacji płatności');
					goToNextPage();
				}
			});
		} else {
			errorMessage();
		}
	}
	function success(paymentData) {

		if (mopPaymentDataManager.hasCorrectAccountRecurringPaymentData(paymentData, config)) {
			mopPaymentDataManager.save(mopPaymentDataManager.build(paymentData, config));
			goToNextPage();
		} else {
			console.log('SI: sprawdzenie stanu');
			var timeout = config.mopTimeout;
			var revisions = config.mopRevisions;
			function check() {
				$.ajax({
					url: '/orderpayment/paymentmodule/transactions/status.ltr',
					data: {
						paymentId: config.paymentModuleDataId
					},
					success: function (result) {
						if (result.status === 'COMPLETED') {
							console.log('SI: przejście na finalizację z sukcesem');
							goToNextPage();
						} else if (result.status === 'FAILED') {
							console.log('SI: przejście na finalizację z porażką');
							goToNextPage();
						} else {
							revisions--;
							if (revisions > 0) {
								setTimeout(function () {
									check();
								}, timeout);
							} else {
								console.log('SI: przejście na finalizację po limicie prób');
								goToNextPage();
							}
						}
					},
					error: function () {
						console.log('SI: przejście na finalizację po błędzie komunikacji');
						goToNextPage();
					}
				});
			}
			check();
		}
	}

	return {
		init
	};
});
